import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  Container,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetCustomField,
  APIcreateCustomField,
  APIupdateCustomField,
  APIdeleteCustomField,
} from '../../api/Metadata';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';
import { fetchCustomFields, fetchMetadataGroups } from '../../actions/Metadata';

import AdminCustomFieldEditTabs from '../../components/Admin/CustomFieldEdit/Tabs';
import AdminCustomFieldEditTabContent from '../../components/Admin/CustomFieldEdit/TabContent';
import GoBackToListButton from '../../components/GoBackToListButton';

import {
  getTabUrlParam,
  updateTabUrlParam,
} from '../../helpers';
import { userHasFeature } from '../../helpers/Features';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getUserSetting } from '../../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';

import Loading from '../../components/Loading';
import ErrorBoundary from '../../components/ErrorBoundary';
import NothingFound from '../../components/NothingFound';
import UpgradeBoard from '../../components/UpgradeBoard';
import AdminCustomFieldEditHeader from '../../components/Admin/CustomFieldEdit/Header';

class AdminCustomFieldEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customField: null,
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      blockedFilter: 'all',
      errors: [],
      activeTab: getTabUrlParam() || 'details',
      is404: false,
      loading: true,
      saving: false,
      timestamp: new Date().toISOString(),
    };

    this.searchRef = React.createRef();

    this.handleSave = this.handleSave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSwitchTab = this.handleSwitchTab.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeMetadataGroups = this.handleChangeMetadataGroups.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeRole = this.handleChangeRole.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'orderBy', 'order', 'search'],
      null,
      this.setState.bind(this),
      () => {
        this.loadCustomField();
      },
      { orderBy: 'name', order: 'asc' },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history, location.state);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history, location.state);
    }
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    const { match: prevMatch } = prevProps;
    const { customFieldId } = match.params;
    const { customFieldId: prevCustomFieldId } = prevMatch.params;

    if (customFieldId !== prevCustomFieldId) {
      this.setState(({
        customField: null,
        customFieldId: null,
      }));
      this.loadCustomField();
    }

    handleComponentParams(
      false,
      ['page', 'orderBy', 'order', 'search'],
      prevProps,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'page')) {
          this.loadCustomField();
        } else {
          this.loadCustomField();
        }
      },
      { orderBy: 'name', order: 'asc' },
    );
  }

  loadCustomField() {
    const { match } = this.props;
    const { customFieldId } = match.params;
    if (!customFieldId) {
      this.setState({
        customField: {
          id: null,
          name: '',
          type: 'text',
          required: false,
          show_on_shares: false,
          roles: [],
          metadata_groups: [],
        },
        loading: false,
      });

      return;
    }

    this.setState({
      customFieldId,
      loading: true,
    });

    APIgetCustomField(customFieldId).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          customField: data,
        }, () => {});
      } else {
        this.setState({
          loading: false,
          is404: true,
        });
      }
    }).catch(() => {
      this.setState({
        loading: false,
        is404: true,
      });
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history, location } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history, location.state);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history, location } = this.props;
    handleURLParams({ page }, history, location.state);

    this.setState({ page });
  }

  handleChangeMetadataGroups(metadataGroups) {
    this.setState(prevState => {
      const { customField } = prevState;
      customField.metadata_groups = metadataGroups;

      return { customField };
    });
  }

  handleChangeSearch(e) {
    const { value } = e.target;
    this.setState({ search: value });
  }

  handleClearSearch(e) {
    e.preventDefault();
    const { history, location } = this.props;
    handleURLParams({ search: '', page: 1 }, history, location.state);

    this.searchRef.value = '';
    this.setState({
      search: '',
      page: 1,
    });
  }

  handleKeyDown(e) {
    const { search } = this.state;
    const { history, location } = this.props;

    if (e.key === 'Enter') {
      e.preventDefault();
      handleURLParams({ search, page: 1 }, history, location.state);
      this.setState({ page: 1 });
    }
  }

  resetState() {
    this.setState({
      saving: false,
      errors: [],
    });
  }

  handleError() {
    const {
      intl,
    } = this.props;
    this.resetState();
    addFlashMessage({
      type: 'danger',
      text: intl.formatMessage({ defaultMessage: 'Something went wrong! Please try again.' }),
    });
  }

  saveCustomField() {
    const {
      customField,
      customFieldId,
    } = this.state;
    const {
      intl,
      history,
      fetchAllCustomFields,
      loadMetadataGroups,
    } = this.props;

    if (!customField.name) {
      this.setState({ errors: ['name'] });
      return;
    }

    this.setState({
      saving: true,
      errors: [],
    });

    if (customFieldId) {
      APIupdateCustomField(customField).then(() => {
        loadMetadataGroups();
        fetchAllCustomFields();
        this.resetState();
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The changes have been saved' }),
        });
      }).catch(() => {
        this.handleError();
      });
    } else {
      APIcreateCustomField(customField).then((response) => {
        loadMetadataGroups();
        fetchAllCustomFields();
        this.resetState();
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The new Custom Field has been created' }),
        });
        const { data } = response;
        if (data && data.id) {
          history.push(`/admin/settings/custom-fields/${data.id}/edit`);
        }
      }).catch(() => {
        this.handleError();
      });
    }
  }

  handleSave() {
    this.saveCustomField();
  }

  handleSwitchTab(tab) {
    this.setState({ activeTab: tab });
    updateTabUrlParam(tab);
  }

  handleChange(e) {
    const {
      value,
      name,
      checked,
    } = e.target;
    const { customField } = this.state;
    if (['name', 'type'].includes(name)) {
      customField[name] = value;
    }
    if (name === 'required') {
      customField.required = checked;
    }
    if (name === 'show_on_shares') {
      customField.show_on_shares = checked;
    }
    this.setState({ customField });
  }

  handleChangeRole(roleId, permission, value) {
    this.setState((prevState) => {
      const { customField } = prevState;
      const existingRole = customField.roles.find(role => role.id === roleId);

      let role;

      if (existingRole) {
        role = {
          ...existingRole,
          [permission]: value,
        };
      } else {
        role = {
          id: roleId,
          can_view: true,
          can_edit: true,
          [permission]: value,
        };
      }

      // Permission dependencies
      if (permission === 'can_view' && value === false) {
        role.can_edit = false;
      }

      if (permission === 'can_edit' && value === true) {
        role.can_view = true;
      }

      const roles = existingRole
        ? customField.roles.map(r => (r.id === roleId ? role : r))
        : [...customField.roles, role];

      return { customField: { ...customField, roles } };
    });
  }

  handleDelete(e) {
    e.preventDefault();
    const {
      history,
      handleDeleteCustomField,
    } = this.props;
    const { customField } = this.state;

    handleDeleteCustomField(customField, () => {
      history.push('/admin/settings/custom-fields');
    });
  }

  render() {
    const {
      customField,
      customFieldId,
      is404,
      loading,
    } = this.state;

    if (is404) {
      return (
        <NothingFound />
      );
    }

    if (customField && !userHasFeature('custom-fields')) {
      return (
        <UpgradeBoard feature="custom-fields" />
      );
    }

    return (
      <div className="settings-inner-content">
        <div className="main-content custom-field-edit-content">
          <Container fluid>
            {loading ? (
              <Loading />
            ) : (
              <ErrorBoundary>
                <GoBackToListButton
                  scope="custom-fields"
                />
                <AdminCustomFieldEditHeader
                  customFieldId={customFieldId}
                />
                <AdminCustomFieldEditTabs
                  {...this.state}
                  handleSwitchTab={this.handleSwitchTab}
                />
                <ErrorBoundary>
                  <AdminCustomFieldEditTabContent
                    {...this.state}
                    handleChange={this.handleChange}
                    handleChangeRole={this.handleChangeRole}
                    handleSave={this.handleSave}
                    handleDelete={this.handleDelete}
                    handleChangeMetadataGroups={this.handleChangeMetadataGroups}
                  />
                </ErrorBoundary>
              </ErrorBoundary>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  handleDeleteCustomField: (customField, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this Custom Field?' }),
      onConfirm: () => (
        APIdeleteCustomField(customField.id).then(() => {
          dispatch(fetchCustomFields());
          callback(customField);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
  openCustomFieldDeleteModal: (params) => {
    dispatch(showModal('CustomFieldDeleteModal', params));
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  fetchAllCustomFields: () => {
    dispatch(fetchCustomFields());
  },
  loadMetadataGroups: () => {
    dispatch(fetchMetadataGroups());
  },
});

AdminCustomFieldEdit.propTypes = {
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleDeleteCustomField: PropTypes.func.isRequired,
  openCustomFieldDeleteModal: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  fetchAllCustomFields: PropTypes.func.isRequired,
  loadMetadataGroups: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminCustomFieldEdit)));
